<template>
  <div class="frisbuy-popup-overlay" @click="closePopup">
    <div
      :class="{ 'frisbuy-popup': true, 'frisbuy-scroller': true }"
      @click.stop
      ref="iuPopup"
    >
      <div class="frisbuy-popup-controls">
        <div class="frisbuy-popup-navigation">
          <div
            class="frisbuy-popup-control frisbuy-prev"
            @click="changePost(4)"
          >
            <svg viewBox="0 0 24 43">
              <path d="M21,0.976190476 L0.923190379,20.5749808" id="Line"></path>
              <path d="M21,20.5 L0.923190379,40.0987903" id="Line" transform="translate(11.000000, 30.261905) scale(1, -1) translate(-11.000000, -30.261905) "></path>
            </svg>
          </div>
          <div
            class="frisbuy-popup-control frisbuy-next"
            @click="changePost(5)"
          >
            <svg viewBox="0 0 24 43">
              <path d="M21,0.976190476 L0.923190379,20.5749808" id="Line"></path>
              <path d="M21,20.5 L0.923190379,40.0987903" id="Line" transform="translate(11.000000, 30.261905) scale(1, -1) translate(-11.000000, -30.261905) "></path>
            </svg>
          </div>
        </div>
      </div>
      <div class="frisbuy-content-wrapper frisbuy-scroller" ref="scrollWrapper">
        <div class="frisbuy-popup-content">
          <div class="frisbuy-popup-media">
            <img
              :src="`${envDomain}/images/gulliver_wear_new.png`"
              style=""
            />
          </div>
        </div>
        <div class="frisbuy-popup-details">
          <div
            class="frisbuy-popup-control frisbuy-close"
            :style="{ cursor: 'pointer' }"
            @click="closePopup"
          >
            <svg
                viewBox="0 0 26 26"
                :style="{
                'stroke-width': 2,
                stroke: '#000',
                width: '20px',
                height: '20px',
                position: 'absolute',
                right: 0,
                top: 0
              }">
              <path d="M22.8863702,1.11362984 L0.52753736,23.4724626" id="Line" transform="translate(12.000000, 12.000000) scale(1, -1) translate(-12.000000, -12.000000) "></path>
              <path d="M22.8863702,1.11362984 L0.52753736,23.4724626" id="Line" transform="translate(12.000000, 12.000000) scale(-1, -1) translate(-12.000000, -12.000000) "></path>
            </svg>
          </div>
          <div
            class="frisbuy-details-scroller frisbuy-scroller"
            ref="scrollDetails"
          >
            <div class="pn-ad-title">
              ДОБАВЬТЕ СВОЕ ФОТО/ВИДЕО<br />В ГАЛЕРЕЮ ОТЗЫВОВ!
            </div>
            <div class="pn-ad-description">
              Загружайте свои фото или видео в образе с товарами Gulliver прямо
              на сайте или ставьте хештег #glvr в соцсетях, чтобы попасть в
              галерею наших любимых образов!
            </div>
            <a
              class="pn-ad-upload-button"
              widget-iu-button="true"
              onclick="iuWidget.open()"
              >загрузите через сайт</a
            >
            <div class="pn-ad-tag-text">
              ИЛИ В VK –
              <span @click="copyToClipboard" style="cursor: pointer"
                >#GLVR</span
              >
            </div>
            <div class="pn-ad-divider"></div>
            <div class="pn-ad-hint">
              * Загружая фотографии, вы подтверждаете свое согласие с нашими
              <a target="_blank" href="https://www.gulliver.ru/offer"
                >правилами обработки персональных данных</a
              >.
            </div>
          </div>
        </div>
      </div>
      <transition name="le-hash" v-on:after-enter="hashCopied = false">
        <div class="le-hash-copied" v-if="hashCopied">хештег скопирован</div>
      </transition>
    </div>
  </div>
</template>

<script>
const bodyScrollLock = require('body-scroll-lock');

export default {
  data() {
    return {
      hashCopied: false
    };
  },

  props: ['settings'],

  methods: {
    closePopup() {
      this.$emit('close-ad-popup');
    },

    changePost(index) {
      this.$emit('open-post', index);
    },

    copyToClipboard() {
      const input = document.createElement('input');
      const { scrollDetails } = this.$refs;

      input.setAttribute('value', '#GLVR');
      input.style.position = 'absolute';
      input.style.opacity = 0;
      input.style.pointerEvents = 'none';
      scrollDetails.appendChild(input);
      input.focus();
      input.select();
      document.execCommand('copy');
      scrollDetails.removeChild(input);
      document.getSelection().removeAllRanges();

      this.hashCopied = true;
    }
  },

  mounted() {
    bodyScrollLock.disableBodyScroll(this.$refs.scrollWrapper);
    this.sendAnaliticEvent('Click_ad_post', window.location.href);
  },

  beforeUnmount() {
    bodyScrollLock.clearAllBodyScrollLocks();
  }
};
</script>
